import { useState, useEffect } from "react";
import CustomCheckBox from "../../assets/components/CustomCheckBox";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";

function CheckBoxItem({ item, checked, disabled, handleCheckboxChange, formId, fieldId }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    getRemainingCount();
  }, []);

  const getRemainingCount = async () => {
    try {
      const data = await appApi.post(`/formfilled/count/selection`, {
        form: formId,
        selectionId: item._id,
        userInput: item.title,
        formField: fieldId,
      });
      setCount(data.data.entries);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <div className="mr-3 my-3 d-flex">
      <CustomCheckBox
        key={item.id}
        label={item.title}
        val={checked}
        disabled={disabled}
        handleChange={(checked) =>
          handleCheckboxChange(item.id, item.title, checked)
        }
      />
      {item.limits.count && (
        <p className="mb-0 mr-1">(ظرفیت باقی مانده: {count})</p>
      )}
    </div>
  );
}

export default CheckBoxItem;
